import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'rate-groups';

export type RateGroup = definitions['RATE_GROUP'] & {
  termsAndCondition: string;
};
export type RateGroupParams = definitions['GET_RATE_GROUPS_QUERY'];
export type CreateRateGroupBody = definitions['CREATE_RATE_GROUP_BODY'];
export type UpdateRateGroupBody = definitions['UPDATE_RATE_GROUP_BY_ID_BODY'];

const list = async (params: RateGroupParams): Promise<API.Response<Array<RateGroup>>> => {
  return await cruisesAPI.http.get({ resource, queryString: JSON.stringify(params) });
};

const create = async (body: CreateRateGroupBody): Promise<RateGroup> => {
  const response = await cruisesAPI.http.post<API.Response<RateGroup>>({
    resource,
    body,
  });

  return response.result;
};

const update = async (id: string, body: UpdateRateGroupBody): Promise<RateGroup> => {
  const response = await cruisesAPI.http.put<RateGroup>({
    resource: `${resource}/${id}`,
    body,
  });

  return response.result;
};

const deleteById = async (id: string): Promise<void> => {
  await cruisesAPI.http.delete({ resource: `${resource}/${id}` });
};

export default {
  list,
  create,
  update,
  deleteById,
};
